import $ from 'jquery';

class FlexibleCards {
	constructor() {
		this.init();
	}

	init() {
		var self = this;

		$('.flexible-card-panel').on('click', function (e) {
			var $parent = $(this).closest('.card');

			if ($(e.target).hasClass('card-headline') || $(e.target).hasClass('btn')) {
				$parent.toggleClass('overlay-active');
			}
		});
	}
}

export default FlexibleCards;
